import { render } from "./actionsMenu.vue?vue&type=template&id=017a1f8c&scoped=true"
import script from "./actionsMenu.vue?vue&type=script&lang=js"
export * from "./actionsMenu.vue?vue&type=script&lang=js"

import "./actionsMenu.vue?vue&type=style&index=0&id=017a1f8c&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017a1f8c"]])

export default __exports__